import { TextField, styled } from "@mui/material";
export const CustomTextarea = styled(TextField)(() => ({
  // width: "100%",
  flexGrow: "1",
  justifyContent: "center",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    // border: "1px solid #e5e7eb",
    // borderRadius: "8px",
    color: "#6f7081",
    padding: "0px 0px 0px 30px;",
    "&:hover": {
      backgroundColor: "transparent",
      // border: "1px solid #e5e7eb",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      // border: "1px solid #e5e7eb",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    padding: "0",
  },

  "& .MuiSelect-icon": {
    color: "#6f7081 !important",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));
